import type { GeofenceCandidate } from '@/lib/geofence-match'
import type { LocationGeometry } from '@/types/locations'
import type { Locations } from '@/types/pbSchema'

// LocationRecord.geometry is typed `any` because pbtsdb generates JSON fields
// that way; narrow at the boundary instead of casting.
export function asGeoJSONPoint(value: unknown): LocationGeometry | null {
    if (!value || typeof value !== 'object') return null
    const obj = value as Record<string, unknown>
    if (obj.type !== 'Point') return null
    if (!Array.isArray(obj.coordinates) || obj.coordinates.length < 2) return null
    const [lng, lat] = obj.coordinates
    if (typeof lng !== 'number' || typeof lat !== 'number') return null
    if (typeof obj.radius !== 'number') return null
    return { type: 'Point', coordinates: [lng, lat], radius: obj.radius }
}

// Narrows org location rows into geofence-match candidates: drops inactive
// locations, ones the user suppressed this session (tapped Undo on), and ones
// without valid Point geometry. This runs before the auto-start path fetches a
// GPS fix, so it directly controls which sites can auto-clock-in.
export function buildCandidates(rows: Locations[], suppressed: Set<string>): GeofenceCandidate[] {
    const candidates: GeofenceCandidate[] = []
    for (const loc of rows) {
        if (loc.inactive) continue
        if (suppressed.has(loc.id)) continue
        const geometry = asGeoJSONPoint(loc.geometry)
        if (!geometry) continue
        const [longitude, latitude] = geometry.coordinates
        candidates.push({
            id: loc.id,
            job: loc.job,
            org: loc.org,
            latitude,
            longitude,
            radius: geometry.radius,
        })
    }
    return candidates
}
